import type { AttachBilletterieOrderData, SettleBilletterieOrderData } from '@cpce/shared';
import { commiteeMutation, MutationMethod } from '@/api/mutations.utils';
import { alertsQueryKeys } from '../alerts/alerts.query-keys';
import { employeesQueryKeys } from '../employees/employees.query-keys';
import { prestationsQueryKeys } from '../prestations/prestations.query-keys';
import { billetterieOrdersQueryKeys } from './billetterie-orders.query-keys';

const ORDER_BOOKING_QUERY_KEYS = [
  billetterieOrdersQueryKeys.all,
  employeesQueryKeys.all,
  prestationsQueryKeys.all,
  alertsQueryKeys.all,
];

export function useAttachBilletterieOrder() {
  return commiteeMutation<
    { participationId: number; settled: boolean },
    AttachBilletterieOrderData,
    AttachBilletterieOrderData & { orderId: number }
  >({
    url: ({ orderId }) => `/commitee/:commiteeId/billetterie-orders/${orderId}/attach`,
    method: MutationMethod.POST,
    body: ({ checkoutCompletedAt, cardId }) => ({ checkoutCompletedAt, cardId }),
    successMessage: 'Commande rattachée à la comptabilité du CSE',
    invalidateQueries: ORDER_BOOKING_QUERY_KEYS,
  });
}

export function useSettleBilletterieOrder() {
  return commiteeMutation<
    void,
    SettleBilletterieOrderData,
    SettleBilletterieOrderData & { orderId: number }
  >({
    url: ({ orderId }) => `/commitee/:commiteeId/billetterie-orders/${orderId}/settle`,
    method: MutationMethod.POST,
    body: ({ instrumentNumber }) => ({ instrumentNumber }),
    successMessage: 'Règlement enregistré',
    invalidateQueries: ORDER_BOOKING_QUERY_KEYS,
  });
}

export function useSyncBilletterieOrders() {
  return commiteeMutation<void>({
    url: '/commitee/:commiteeId/billetterie-orders/sync',
    method: MutationMethod.POST,
    successMessage: 'Lecture des commandes lancée',
    invalidateQueries: [billetterieOrdersQueryKeys.all],
  });
}
